import React from "react";
import { Stars, onestar } from "../../assets/images";
import { RatingType } from "../../types";
import { daysBetweenDates } from "../../utils/daysBetweenDates";

type TestimonialProps = {
  rating: RatingType;
};

const VehicleTestimonial: React.FC<TestimonialProps> = ({ rating }) => {
  return (
    <div className="flex flex-col gap-[13px]  md:w-[52%] lg:w-[30%] py-[25px] mx-auto bg-white p-5 border rounded-lg w-64  flex-shrink-0 m-2">
      {/* <img src={img} alt="" className="h-[101px] object-contain" /> */}
      <p className=" text-base rounded-full p-2 bg-midGreen max-w-fit mx-auto text-white">
        {rating.ratedBy.firstName[0].toUpperCase()}
        {""}
        {rating.ratedBy.lastName[0].toUpperCase()}
      </p>
      <p className=" text-black text-center font-Inter font-bold text-[14px] md:text-[23px] leading-9">
        {rating.ratedBy.firstName} {""} {rating.ratedBy.lastName}
      </p>
      <div className="flex flex-row w-full">
        <p className=" text-[#FBAD39] w-1/2 items-center flex flex-row gap-2 text-center font-Inter text-[12px] md:text-[18px] font-normal leading-7 ">
          <img src={onestar} alt="" className=" w-6 h-6" />
          {rating.meanRating.toFixed(1) ?? "0.0"}
        </p>
        <p className=" w-1/2 text-[#525252]  border-l-[1px] border-[#525252] text-center font-Inter text-[12px] md:text-[18px] font-normal leading-7 ">
          {daysBetweenDates(rating.createdAt, new Date().toISOString())} days
          ago
        </p>
      </div>
      <p className=" text-[#696969] text-center font-Inter text-[10px] md:text-[16px] font-normal md:leading-7">
        {rating.comment}
      </p>
    </div>
  );
};

export default VehicleTestimonial;
